import React from 'react';
import './How_It_Work.css';
import Common_Headings from '../../common_components/common_heading/Common_Headings';

const How_It_Work = () => {
  return (
    <section className="hiw container">
      <div className="hiw__container ">
          <Common_Headings title="HOW IT WORKS" />

        <div className="hiw__steps-wrapper">
  
          <div className="hiw__step">
            <div className="hiw__icon-box">
              <img src="/assets/About_us/Searchicon.png" alt="Search" />
            </div>
            <div className="hiw__number">01</div>
            <h3 className="hiw__heading">Search</h3>
            <p className="hiw__text">Customers browse nearby vendors or experts</p>
          </div>


          <div className="hiw__step">
            <div className="hiw__icon-box">
              <img src="/assets/About_us/choose.png" alt="Choose" />
            </div>
            <div className="hiw__number">02</div>
            <h3 className="hiw__heading">Choose</h3>
            <p className="hiw__text">View profiles, services, and contact details</p>
          </div>

  
          <div className="hiw__step">
            <div className="hiw__icon-box">
              <img src="/assets/About_us/connect.png" alt="Connect" />
            </div>
            <div className="hiw__number">03</div>
            <h3 className="hiw__heading">Connect</h3>
            <p className="hiw__text">Call directly to discuss requirements</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default How_It_Work;